'use client';

import React from 'react';
import classNames from 'classnames';
import { useJobs } from '@gate-js/react';
import {
	getFieldOptionLabels,
	getListWrapperClassName,
	getOptionClasses,
	getOptionStyle,
	getCountBadgeStyle,
	getCountBadgeClasses,
} from '../selectors/Gate/JobCountHelpers';
import { resolveSetting } from '../../utils/settingsHelper';

export function JobCountClient({ field, variant, settings, labelColor, countColor, titleFontSize, placeholder, showZeroCounts, ...rest }) {
	const { jobs } = useJobs();

	const textStyle = { fontSize: titleFontSize ? `${titleFontSize}px` : undefined };

	const renderRow = (label, count, key, overrides) => {
		const rowProps = overrides ? { ...rest, ...overrides } : rest;
		return (
			<li key={key} className={getOptionClasses(rowProps, settings)} style={getOptionStyle(rowProps, settings)}>
				<span style={{ ...textStyle, color: resolveSetting(labelColor, settings) }}>{label}</span>
				<span
					className={classNames('font-semibold', getCountBadgeClasses(rowProps, settings))}
					style={{ ...textStyle, color: resolveSetting(countColor, settings), ...getCountBadgeStyle(rowProps, settings) }}
				>
					{count === null ? '–' : count}
				</span>
			</li>
		);
	};

	if (!field) {
		return (
			<ul className="w-fit">
				{renderRow(placeholder, jobs ? jobs.length : null, 'total', { justifyBetween: false })}
			</ul>
		);
	}

	const options = (field.options || [])
		.map((option) => ({
			option,
			count: jobs ? jobs.filter((job) => getFieldOptionLabels(job.fields[field.name]).includes(option)).length : null,
		}))
		.filter((item) => showZeroCounts || item.count !== 0);

	return (
		<ul className={getListWrapperClassName(variant)}>
			{options.map(({ option, count }) => renderRow(option, count, option))}
		</ul>
	);
}
